function PlayIconBlue({
  testId,
  className
}: {
  testId?: string;
  className?: string;
}) {
  return (
    <svg
      className={className}
      viewBox="0 0 104 104"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid={testId}
    >
      <circle cx="52" cy="52" r="52" fill="url(#paint0_radial_3930_15864)" />
      <path
        d="M37.1497 70.9192V33.1483C37.1497 30.8185 39.6895 29.3779 41.6891 30.5734L73.6491 49.6816C75.6083 50.8529 75.5936 53.6961 73.6225 54.8471L41.6624 73.5099C39.6625 74.6778 37.1497 73.2352 37.1497 70.9192Z"
        fill="white"
      />
      <defs>
        <radialGradient
          id="paint0_radial_3930_15864"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(71 10) rotate(107.011) scale(114.51)"
        >
          <stop stopColor="#00B2F6" />
          <stop offset="1" stopColor="#0073B9" />
        </radialGradient>
      </defs>
    </svg>
  );
}

export { PlayIconBlue };
